import { Component, inject } from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogActions,
  MatDialogClose
} from "@angular/material/dialog";
import { Visit } from "@app/models/rest/visit";
import { VisitStore } from "@app/services/store/visit-store";
import { VisitStatus } from "@app/models/enums/visit-status.enum";
import { ServiceErrorHandlerService } from "@app/view/shared/service-error-handler.service";
import { MatButton } from "@angular/material/button";

@Component({
  selector: "app-cancel-visit-dialog",
  templateUrl: "./cancel-visit-dialog.component.html",
  styleUrls: ["./cancel-visit-dialog.component.css"],
  imports: [MatDialogTitle, MatDialogActions, MatButton, MatDialogClose]
})
export class CancelVisitDialogComponent {
  visitStore = inject(VisitStore);
  dialogRef = inject<MatDialogRef<CancelVisitDialogComponent>>(MatDialogRef);
  serverErrorHandler = inject(ServiceErrorHandlerService);
  data = inject<{
    visit: Visit;
  }>(MAT_DIALOG_DATA);

  retryCount = 3;

  cancelVisit() {
    this.retryCount = 3;
    this.performCancellation();
  }

  private performCancellation() {
    this.visitStore.loadSingle(this.data.visit.id).then((value: Visit) => {
      value.visitStatus = VisitStatus.CANCELLED;
      this.visitStore.update(value).subscribe(
        () => {
          this.dialogRef.close();
        },
        (error) => {
          this.retryCount--;
          if (this.retryCount > 0) {
            this.performCancellation();
          } else {
            this.serverErrorHandler.handleError(error);
          }
        }
      );
    });
  }
}
